import { useReducer } from "react";
import { MUTATIONS, useMutation } from "../../../../../../api";
import InputText from "../../../../../../design-system/components/InputText/InputText.jsx";
import { isEmail } from "../../../../../../lib/validation-utils.js";
import InputSubmit from "../../../../../../design-system/components/InputSubmit/InputSubmit.jsx";
import styles from "./TeacherInviteForm.css.ts";

const formReducer = (formData, action) => {
  switch (action.type) {
    case "setEmail": {
      return {
        ...formData,
        email: action.email,
      };
    }

    case "setError": {
      return {
        ...formData,
        error: action.error,
      };
    }

    case "clear": {
      return {
        error: null,
        email: "",
      };
    }

    default: {
      throw Error("Unknown action: " + action.type);
    }
  }
};

function TeacherInviteForm({ workshopId }) {
  const [doInviteTeacher] = useMutation(MUTATIONS.inviteTeacher);
  const [formData, dispatch] = useReducer(formReducer, {
    error: null,
    email: "",
  });

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      await doInviteTeacher({
        id: workshopId,
        email: formData.email,
      });

      dispatch({ type: "clear" });
    } catch (error) {
      console.error(error);

      dispatch({
        type: "setError",
        error: error.message,
      });
    }
  }

  function handleChange(e) {
    dispatch({
      type: "setEmail",
      email: e.currentTarget.value.trim(),
    });
  }

  return (
    <form onSubmit={handleSubmit}>
      <section className={styles.section}>
        <header className={styles.header}>
          <h3 className={styles.headline}>Kolleg*innen</h3>
          <p className={styles.description}>
            Lade deine Kolleg*innen ein, damit sie die Lernreise mit verwalten
            können.
          </p>
        </header>
        <div className={styles.containerRight}>
          <p className={styles.descriptionRight}>
            Gebe die Email Adressen deiner Kolleg*innen hier ein
          </p>
          <div className={styles.containerInput}>
            <InputText
              width100
              theme="dark"
              name="email"
              label="E-Mail-Adresse"
              required
              value={formData.email}
              onChange={handleChange}
              error={formData.error}
            />

            <InputSubmit value="Einladen" disabled={!isEmail(formData.email)} />
          </div>
        </div>
      </section>
    </form>
  );
}

export default TeacherInviteForm;
